import { useEffect } from "react";
import { ReactComponent as IMAXLogo } from "../assets/imax.svg";
import { Link, useLocation } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";

import { ActionTypes } from "../store/types";

import { Loader } from "./Loader";

import scss from "./Layout.module.scss";

export const Layout = ({ children }) => {
  const dispatch = useDispatch();
  const { loading } = useSelector((state: any) => state);
  const location = useLocation();

  useEffect(() => {
    if (location.pathname === "/") {
      document.body.style.backgroundImage = `url(/landing-bg.png)`;
    } else {
      document.body.style.backgroundImage = ``;
    }
  }, [location.pathname]);

  useEffect(() => {
    setTimeout(() => {
      dispatch({ type: ActionTypes.SET_LOADING, payload: false });
    }, 2000);
    // eslint-disable-next-line
  }, []);

  const styles = {
    background:
      location.pathname === "/"
        ? "linear-gradient(180deg, rgba(23, 26, 36, 0) 0%, #171A24 51.56%)"
        : "",
  };

  return (
    <div className={scss.container} style={styles}>
      <div className={scss.wrapper}>
        <header className={scss.header}>
          <Link to="/">
            <img
              src="/suicide-squad.png"
              className={`${scss.headerImage} ${
                location.pathname !== "/" ? scss.minimal : ""
              }`}
              alt="The Suicide Squad"
            />
          </Link>
          <h3>FANTASY DRAFT SWEEPSTAKES</h3>
        </header>

        {loading ? <Loader /> : children}

        <footer className={scss.footer}>
          <IMAXLogo width="100%" height="100%" />
          <div className={scss.comics}>
            <p>
              Get DC Comics in Comic Shops
              <br />
              Read DC Digital Comics at{" "}
              <a
                href="https://www.dcuniverseinfinite.com/"
                target="_blank"
                rel="noopener noreferrer"
              >
                DC UNIVERSE INFINITE
              </a>
            </p>
            <p className={scss.copyright}>© 2021 WBEI TM & © DC.</p>
            <p className={scss.copyright}>© 2021 IMAX Corporation.</p>
            <br />
            <p className={scss.copyright}>IMAX® is a registered trademark of IMAX Corporation.</p>
          </div>
        </footer>
      </div>
    </div>
  );
};
